// --- variable product label ---

var wizardCover = document.querySelector('article.is-step-description');
var wizardFooter = document.querySelector('.wcsf-footer');

if (wizardCover) {
    wizardFooter.classList.add('visible');
}